 // TODO - This should be the preferred way to determine type, but the backend is weird like that
    // Ex: question.type === 'TEXT', answer.type === 'IMAGE' is possible....
    // const isOfTypeImage = question.type === 'IMAGE';

const isOfTypeImage = (question) => {
    if (question) {
      return question.answers.some(answer => answer.type === "IMAGE");
    }
    else {
        return false
    }
}

const hexToRgb = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
}

export {isOfTypeImage, hexToRgb}